import { useIntl } from '@atlassian/jira-intl';
import { useCustomSkipLink } from '@atlassian/jira-navigation-system/src/index.tsx';
import messages from './messages.tsx';

export const TopNavigationSkipLink = () => {
	const { formatMessage } = useIntl();

	useCustomSkipLink('ak-jira-navigation', formatMessage(messages.skipToJiraNavigation), 0);

	return null;
};

export const LeftSidebarSkipLink = () => {
	const { formatMessage } = useIntl();

	useCustomSkipLink('ak-side-navigation', formatMessage(messages.skipToSideNavigation), 1);

	return null;
};

export const ProjectViewNavigationSkipLink = () => {
	const { formatMessage } = useIntl();

	useCustomSkipLink(
		'ak-project-view-navigation',
		formatMessage(messages.skipToProjectViewNavigation),
		2,
	);

	return null;
};

export const MainContentSkipLink = () => {
	const { formatMessage } = useIntl();

	useCustomSkipLink('ak-main-content', formatMessage(messages.skipToMainContent), 3);

	return null;
};
